import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";

import {
  IonContent,
  IonPage,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonIcon,
  IonToast,
} from "@ionic/react";

import "./style.css";

import { injectContext, AppProps } from "../../base/AppContext";
import VisibilityOffIcon from "../../assets/icons/VisibilityOffIcon.svg";
import VisibilityIcon from "../../assets/icons/VisibilityIcon.svg";

import { ButtonLoading } from "../../components/Ui/ButtonLoading";

import { useChange } from "../../hooks/useChange";

import { SignUpForm } from "../../interfaces/auth";

import { useSignUp } from "../../hooks/useSignUp";
import { useValidation, options } from "../../hooks/useValidation";

const SignUpPage: React.FC<AppProps> = ({ login, isAuth }) => {
  const { goBack } = useHistory();
  const [showPass, setShowPass] = useState<boolean>(false);
  const [state, setState] = useState<{ form: SignUpForm }>({
    form: {
      name: "",
      phone: "",
      email: "",
      password: "",
    },
  });

  const { setError, isValid } = useValidation(state.form as options, {
    name: false,
    password: false,
    email: false,
    username: false,
  });

  const { onIonChange } = useChange({ setState, setFormError: setError });

  const onSignUpSuccess = (res: any) => {
    // login(res.token_id);
  };

  const {
    onSignUpHandle,
    loading,
    error,
    success,
    userExist,
    cancelError,
    cancelUserExist,
    cancelSuccess,
  } = useSignUp(state.form, onSignUpSuccess);

  const onSubmit = (event: any) => {
    event.preventDefault();
    onSignUpHandle();
  };

  const doneSuccess = () => {
    cancelSuccess();
    goBack();
  };

  if (isAuth) {
    return <Redirect to="/page/passages" />;
  }

  return (
    <IonPage>
      <IonContent className="background-content">
        <IonToast
          isOpen={error}
          position="bottom"
          message="Não foi possível cria o usuário"
          duration={3000}
          onDidDismiss={() => cancelError()}
          buttons={[
            { text: "Ok", role: "cancel", handler: () => cancelError() },
          ]}
        />
        <IonToast
          isOpen={userExist}
          position="bottom"
          message="Os dados fornecidos já foram usados em outro cadastro!"
          duration={3000}
          onDidDismiss={() => cancelUserExist()}
          buttons={[
            { text: "Ok", role: "cancel", handler: () => cancelUserExist() },
          ]}
        />
        <IonToast
          isOpen={success}
          position="bottom"
          message="Usuário criado com sucesso!"
          duration={3000}
          onDidDismiss={() => doneSuccess()}
          buttons={[
            { text: "Ok", role: "cancel", handler: () => doneSuccess() },
          ]}
        />
        <div className="sign-up-page">
          <div className="sign-up-page-panel">
            <div className="sign-up-panel-form">
              <div className="sign-up-panel-form-title">
                <h2>Criação de nova conta</h2>
              </div>
              <form onSubmit={onSubmit} style={{ width: "90%" }}>
                <div className="sign-up-panel-form-content">
                  <IonItem>
                    <IonLabel position="floating">Nome</IonLabel>
                    <IonInput
                      required
                      onIonChange={onIonChange}
                      value={state.form.name}
                      name="name"
                      type="text"
                    />
                  </IonItem>
                  <IonItem>
                    <IonLabel position="floating">E-mail</IonLabel>
                    <IonInput
                      required
                      onIonChange={onIonChange}
                      name="email"
                      value={state.form.email}
                      type="text"
                    />
                  </IonItem>
                  <IonItem>
                    <IonLabel position="floating">Telefone</IonLabel>
                    <IonInput
                      required
                      onIonChange={onIonChange}
                      value={state.form.phone}
                      name="phone"
                      type="text"
                    />
                  </IonItem>
                  <IonItem>
                    <IonLabel position="floating">senha</IonLabel>
                    <IonInput
                      required
                      type={showPass ? "text" : "password"}
                      value={state.form.password}
                      name="password"
                      onIonChange={onIonChange}
                    />
                    <IonButton
                      className="button-visible-pass"
                      onClick={() => setShowPass(!showPass)}
                      slot="end"
                    >
                      <IonIcon
                        slot="icon-only"
                        icon={showPass ? VisibilityIcon : VisibilityOffIcon}
                      />
                    </IonButton>
                  </IonItem>
                </div>
                <div className="sign-up-panel-form-footer">
                  <ButtonLoading
                    disabled={isValid()}
                    loading={loading}
                    text="Criar"
                    textLoading="Criando..."
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default injectContext(SignUpPage);
